import styled from "styled-components";

const SectionStyle = styled.div`
  padding: 16px 0;
`

export { SectionStyle };